import type {
  BoardStudyPosition,
  BoardStudyAnalysis,
  BrowserEngineRequest,
  NikolaMessagePart,
  NikolaPublicFailureCode,
} from "@chessla/shared";

export const NIKOLA_FAILURE_REPLY = "Nikola couldn't finish answering this time.";

export interface NikolaMessageInput {
  sessionId: string;
  message: string;
  requestId?: string;
  reviewMoment?: { gameId: string };
  study?: BoardStudyPosition;
  studyAnalysis?: BoardStudyAnalysis;
  includeFullGameAnalysis?: boolean;
  context?: { gameId?: string; moveNumber?: number; movePerspective?: "player" | "opponent"; ply?: number };
}

export interface PendingAction {
  type: "start_game_analysis" | "evaluate_line" | "browser_engine";
  runId?: string;
  actionId?: string;
  stepId?: string;
  idempotencyKey?: string;
  gameId?: string;
  analysisPreset?: "regular" | "quick" | "deep";
  analysisMode?: "ensure" | "reanalyze";
  fen?: string;
  description?: string;
  maxPlies?: number;
  request?: BrowserEngineRequest;
}

export interface SendMessageResult {
  reply: string;
  parts?: readonly NikolaMessagePart[];
  status: "complete" | "thinking" | "failed";
  pendingAction?: PendingAction | null;
  creditsCharged?: number;
  failureCode?: NikolaPublicFailureCode;
  failureMessage?: string;
  retryable?: boolean;
}
